import { render, staticRenderFns } from "./FunnelDraftNotice.vue?vue&type=template&id=2e5c4cb7&scoped=true"
import script from "./FunnelDraftNotice.vue?vue&type=script&lang=js"
export * from "./FunnelDraftNotice.vue?vue&type=script&lang=js"
import style0 from "./FunnelDraftNotice.vue?vue&type=style&index=0&id=2e5c4cb7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e5c4cb7",
  null
  
)

export default component.exports